export default __webpack_public_path__ + "static/VISA-Conditions-of-Use-5e89780424b399114a8a7642bca77cc8.pdf";